import * as React from 'react';
import { 
  Button, 
  Dialog, 
  DialogActions, 
  DialogContent, 
  DialogContentText, 
  DialogTitle,
  Box,
  Typography,
  Divider
} from '@mui/material';
import { Warning } from '@mui/icons-material';

import Events from '../service/Events';

class WarningPopup extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            open: false,
            text: null,
            title: null,
            onAgree: () => { }
        };
    }

    componentDidMount() {
        Events.onAlert.on("warning", (title, text, onAgree) => {
            this.setState({ open: true, title, text, onAgree });
        });
    }

    handleClose = () => {
        this.setState({ open: false });
    };

    render() {
        return (
            <Dialog
                open={this.state.open}
                onClose={this.handleClose}
                maxWidth="sm"
                fullWidth
                PaperProps={{
                    sx: {
                        borderRadius: { xs: '12px', sm: '20px' },
                        overflow: 'hidden',
                        margin: { xs: '16px', sm: '32px' },
                        maxHeight: { xs: 'calc(100vh - 32px)', sm: '90vh' }
                    }
                }}
            >
                {/* Header with gradient */}
                <Box
                    sx={{
                        background: 'linear-gradient(135deg, #ed6c02 0%, #ff9800 100%)',
                        pt: { xs: 2.5, sm: 3 },
                        pb: { xs: 2.5, sm: 3 },
                        px: { xs: 2, sm: 3 },
                        color: 'white',
                        display: 'flex',
                        alignItems: 'center',
                        gap: { xs: 1.5, sm: 2 }
                    }}
                >
                    <Warning sx={{ fontSize: { xs: '1.8rem', sm: '2.5rem' } }} />
                    <DialogTitle sx={{ p: 0, flex: 1 }}>
                        <Typography variant="h5" sx={{ fontWeight: 700, color: 'white', fontSize: { xs: '1.25rem', sm: '1.5rem' } }}>
                            {this.state.title}
                        </Typography>
                    </DialogTitle>
                </Box>

                <DialogContent sx={{ pt: { xs: 2, sm: 3 }, pb: { xs: 1, sm: 2 }, px: { xs: 2, sm: 3 } }}>
                    <DialogContentText 
                        id="alert-dialog-description"
                        sx={{ 
                            fontSize: { xs: '0.9rem', sm: '1rem' },
                            color: '#333',
                            lineHeight: 1.6
                        }}
                    >
                        {this.state.text}
                    </DialogContentText>
                </DialogContent>

                <Divider />

                <DialogActions sx={{ 
                    p: { xs: 2, sm: 3 }, 
                    gap: { xs: 1.5, sm: 2 },
                    flexDirection: { xs: 'column', sm: 'row' }
                }}>
                    <Button 
                        onClick={this.handleClose}
                        variant="outlined"
                        size="large"
                        fullWidth
                        sx={{
                            borderRadius: '10px',
                            textTransform: 'none',
                            fontWeight: 600,
                            borderColor: '#ddd',
                            color: '#666',
                            fontSize: { xs: '0.9rem', sm: '1rem' },
                            py: { xs: 1.2, sm: 1.5 },
                            order: { xs: 2, sm: 1 },
                            '&:hover': {
                                borderColor: '#bbb',
                                bgcolor: '#f5f5f5'
                            }
                        }}
                    >
                        Abbrechen
                    </Button>
                    <Button 
                        onClick={(ev) => {
                            this.handleClose();
                            this.state.onAgree();
                        }} 
                        variant="contained"
                        size="large"
                        fullWidth
                        autoFocus
                        sx={{
                            bgcolor: '#ed6c02',
                            color: 'white',
                            fontWeight: 600,
                            textTransform: 'none',
                            fontSize: { xs: '0.9rem', sm: '1rem' },
                            py: { xs: 1.2, sm: 1.5 },
                            borderRadius: '10px',
                            boxShadow: '0 4px 12px rgba(237, 108, 2, 0.3)',
                            order: { xs: 1, sm: 2 },
                            '&:hover': {
                                bgcolor: '#e65100',
                                boxShadow: '0 6px 16px rgba(237, 108, 2, 0.4)',
                                transform: 'translateY(-2px)'
                            },
                            transition: 'all 0.2s ease'
                        }}
                    >
                        Bestätigen
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

export default WarningPopup;